import type { ButtonHTMLAttributes, ReactNode } from "react";

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  children: ReactNode;
  active?: boolean;
  variant?: "default" | "own";
}

export function Chip({
  children,
  active = false,
  variant = "default",
  className = "",
  ...rest
}: Props) {
  const isOwn = variant === "own";
  const base =
    "inline-flex items-center gap-[6px] rounded-full px-[16px] py-[9px] text-[14px] font-medium transition-colors active:opacity-80";
  const skin = isOwn
    ? active
      ? "border border-accent/60 bg-accent/10 text-accent italic font-display font-light"
      : "border border-dashed border-ink/40 text-ink/75 italic font-display font-light"
    : active
      ? "bg-ink text-paper border border-ink"
      : "border border-ink/20 text-ink bg-transparent";
  return (
    <button className={`${base} ${skin} ${className}`} {...rest}>
      {isOwn && (
        <span className="not-italic font-sans font-light text-[16px] leading-none">
          {active ? "−" : "+"}
        </span>
      )}
      {children}
    </button>
  );
}
